import { Card, Divider, Stack, Text } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import { RenderDataIdentityList, RenderTopIdentitySubMerchant } from './extendFragment';
import CardCoordinateMerchant from '../../components/fragments/CardCoodinateMerchant';
import { RenderModalBlockSubMerchant, RenderModalConfirmationAction, RenderModalLimitRequestPin } from './Modal';
import { AppContext, ToastrContext } from '../../contexts';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearRedux, fetchDetailSubMerchant, subMerchantAction } from './actions';
import { mappingDataIdentity, mappingDataMerchant, mappingDataUser } from './constants';
import { useTimer } from 'react-timer-hook';
import { formatCountdown } from '../../utils/format';
import { fetchSessionProtection } from '../../components/layouts/PageBase/actions';

const SettingSubMerchant = () => {
  const dispatch = useDispatch();
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);
  const location = useLocation();
  const subMerchantId = location.pathname.split('/').pop();
  const [detailType, setDetailType] = useState('masked');
  const [modal, setModal] = useState({
    type: 'confirmPin',
    opened: false
  });

  const dataDetail = useSelector((s) => s.settingSubMerchant);

  const { minutes, seconds, restart } = useTimer({
    expiryTimestamp: new Date(),
    autoStart: false
  });

  const handleModalClose = () => {
    setModal({
      type: modal.type,
      opened: false
    });
  };

  const handleSubmitBlock = (payload) => {
    dispatch(subMerchantAction({
      subUserId: dataDetail?.masked?.data?.subUserId,
      reason: payload?.reason === 'other' ? payload?.otherReason : payload?.reason
    }, 'block'));
  };

  const handleSubMerchantAction = (key = 'resend') => {
    dispatch(subMerchantAction({
      subUserId: dataDetail?.masked?.data?.subUserId
    }, key));
  };

  useEffect(() => {
    dispatch(fetchSessionProtection());
    setBreadcrumbs([
      {
        name: 'Cari Data Subpangkalan LPG 3 Kg',
        to: '/sub-merchant/setting-data-sub-merchant/search',
      },
      'Setting Data Subpangkalan LPG 3 Kg']);
  }, []);

  useEffect(() => {
    if(dataDetail?.resend?.success){
      handleModalClose();
      setToastr({
        visible: true,
        type: 'success',
        desc: (<span>Berhasil mengirim permintaan atur ulang PIN ke Whatsapp
          <b> {dataDetail?.masked?.data?.identity?.name}</b></span>)
      });
      dispatch(clearRedux('resend'));
    }else if(dataDetail?.resend?.code === 429){
      setModal({
        type: 'alreadyRequestPin',
        opened: true
      });
      restart(dataDetail?.resend?.data?.countDownTime);
    }
  }, [dataDetail?.resend?.loading]);

  useEffect(() => {
    if(dataDetail?.block?.success){
      handleModalClose();
      setToastr({
        visible: true,
        type: 'success',
        desc: (<span>Berhasil blok <b>{dataDetail?.masked?.data?.identity?.name}</b></span>)
      });
      dispatch(fetchDetailSubMerchant(subMerchantId, detailType));
      dispatch(clearRedux('block'));
    }
  }, [dataDetail?.block?.loading]);

  useEffect(() => {
    if(dataDetail?.unblock?.success){
      handleModalClose();
      setToastr({
        visible: true,
        type: 'success',
        desc: (
          <span>Berhasil membuka blokir <b>{dataDetail?.masked?.data?.identity?.name}</b></span>
        )
      });
      dispatch(fetchDetailSubMerchant(subMerchantId, detailType));
      dispatch(clearRedux('unblock'));
    }
  }, [dataDetail?.unblock?.loading]);

  useEffect(() => {
    dispatch(fetchDetailSubMerchant(subMerchantId, detailType));
  }, [detailType]);

  return (
    <Stack>
      <Card p={0}>
        <RenderTopIdentitySubMerchant
          dataContent={dataDetail?.[detailType]?.data}
          detailType={detailType}
          isLoading={dataDetail?.masked?.loading || dataDetail?.plain?.loading}
          setDetailType={setDetailType}
          setModal={setModal}
        />
        <Divider/>
        <RenderDataIdentityList isLoading={dataDetail.masked.loading ||  dataDetail.plain.loading}
          listContent={mappingDataIdentity(dataDetail?.[detailType]?.data?.identity)} title="Data Identitas" />
        <Divider/>
        <RenderDataIdentityList
          isLoading={dataDetail.masked.loading ||  dataDetail.plain.loading}
          listContent={mappingDataUser(dataDetail?.[detailType]?.data?.business)} title="Data Pengguna"/>
        <Divider/>
        <RenderDataIdentityList listContent={mappingDataMerchant(dataDetail?.[detailType]?.data?.merchant)} title="Pangkalan Tempat Daftar" withBorder withTitleIcon />
      </Card>
      <CardCoordinateMerchant data={{ coordinate: dataDetail?.[detailType]?.data?.coordinate }}/>
      {modal.type === 'confirmPin' && <RenderModalConfirmationAction btnTextPrimary={'Kirim'}
        btnTextSecondary="Batal"
        contentBody={<Text ta="center">Apakah Anda ingin mengirim permintaan atur ulang PIN
        ke Whatsapp <b>{dataDetail?.masked?.data?.identity?.name}?</b></Text>}
        onClose={handleModalClose}
        onConfirm={() => handleSubMerchantAction('resend')}
        opened={modal.opened}
        title="Atur Ulang PIN"
      />}
      {modal.type === 'limitPin' && <RenderModalLimitRequestPin
        contentBody={<Text>Anda sudah melakukan 3 kali permintaan atur ulang
           PIN ke WhatsApp, silakan coba lagi di hari berikutnya.</Text>}
        onClose={handleModalClose}
        opened={modal.opened}
        title="Tidak Dapat Atur Ulang PIN"
      />}
      {modal.type === 'alreadyRequestPin' && <RenderModalLimitRequestPin
        contentBody={<Text ta="center">Anda telah melakukan permintaan atur ulang
           PIN ke Whatsapp
        <b> {dataDetail?.masked?.data?.identity?.name}</b>.
         Harap tunggu hingga <b>{formatCountdown(minutes, seconds)}</b></Text>}
        onClose={handleModalClose}
        opened={modal.opened}
        title="Tidak Dapat Atur Ulang PIN"
      />}
      {modal.type === 'confirmUnblock' && <RenderModalConfirmationAction
        btnTextPrimary="Buka Blokir Subpangkalan"
        btnTextSecondary="Batal"
        contentBody={<Text mb="md" ta="center">Apakah Anda ingin membuka blokir <b>{dataDetail?.masked?.data?.identity?.name}?</b>
        </Text>}
        onClose={handleModalClose}
        onConfirm={() => handleSubMerchantAction('unblock')}
        opened={modal.opened}
        title="Buka Blokir Subpangkalan"
      />}
      {modal.type === 'block' &&<RenderModalBlockSubMerchant handleSubmit={handleSubmitBlock} onClose={handleModalClose} opened={modal.opened}/>}
    </Stack>
  );
};

export default SettingSubMerchant;
